module.exports = __webpack_public_path__ + "images/banners/page_lp_aisatei/banner_sp_5daea38c48ec2b3fcad9e0e2959194d4.webp";